import { FaRegCheckCircle } from "react-icons/fa";

export const StudyUSaDetails = [
  {
    title: "Minimum IELTS Score",
    number: 6.5,
    icon: <FaRegCheckCircle className="text-green-500 text-xl" />,
  },
  {
    title: "Total Universities",
    number: 5400,
    icon: <FaRegCheckCircle className="text-green-500 text-xl" />,
  },
  {
    title: "Minimum TOEFL Score",
    number: 80,
    icon: <FaRegCheckCircle className="text-green-500 text-xl" />,
  },
  {
    title: "Minimum PTE Score",
    number: "50",
    icon: <FaRegCheckCircle className="text-green-500 text-xl" />,
  },
];
